import {hasCancelRequest} from "@/helpers/common";

const actions = {
  async setInsightPackages({ rootState, commit }) {
    const that = this._vm;
    const data = {
      clientID: rootState.common.generalLocalStorageVariables.activeClientID
    }
    const url = 'package/list';

    try {
      const response = await that.$constants('axios').post(url, data);

      commit('setInsightPackages', response.data);
      commit('common/setApisLoadStates', {api: 'insightPackages', isLoaded: true}, {root: true});

    } catch (error) {
      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching the insight packages.Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    }
  },
  async setInsights({ rootState, commit }, packages) {
    const that = this._vm;

    const data = {
      clientID: rootState.common.generalLocalStorageVariables.activeClientID,
      packages: packages,
    }

    const url = 'package/insight/list';

    try {
      const response = await that.$constants('axios').post(url, data);

      const insights = {
        ...response.data,
        packages: packages
      }

      commit('setInsights', insights);
      commit('common/setApisLoadStates', { api: 'insights', isLoaded: true }, { root: true });

    } catch (error) {
      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching insights.Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    }
  },
  async setPackageInsights({ rootState, state, commit }, packageID){
    const that = this._vm;

    const data = {
      clientID: rootState.common.generalLocalStorageVariables.activeClientID,
      packages: [ packageID ],
      have_package_detail: true
    }
    const url = 'package/insight/list';

    try {
      const response = await that.$constants('axios').post(url, data);
      commit('setPackageInsights',  response.data);

    } catch (error) {
      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching insights.Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    }
  },
  async createInsightBookmark({ commit, rootState }, data) {
    const that = this._vm;
    const bookmarkID = rootState.common.generalLocalStorageVariables.activeClientBookmarkID;
    const activeClientID = rootState.common.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/bookmarks/${bookmarkID}/insights`;
    const notification = {
      code: "urgent",
      title: "An error occurred during adding insight to bookmarks.Please try again.",
    }
    commit("notifications/removeNotification", notification, { root: true });

    try {
      const response = await that.$constants("$http").post(url, data);
      return response;

    } catch (error) {

      if (hasCancelRequest(error)) return;

      commit("notifications/setNotification", notification, { root: true });

    }
  },
  async deleteInsightBookmark({ commit, rootState }, data) {
    const that = this._vm;
    const bookmarkID = rootState.common.generalLocalStorageVariables.activeClientBookmarkID;
    const activeClientID = rootState.common.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/bookmarks/${bookmarkID}/insights`;
    const config = { params: data };
    const notification = {
      code: "urgent",
      title: "An error occurred during deleting insight to bookmarks.Please try again.",
    }
    commit("notifications/removeNotification", notification, { root: true });

    try {
      const response = await that.$constants('$http').delete(url, config);
      return response;
    } catch (error) {
      if (hasCancelRequest(error))return;
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async createIgnoredInsight({ commit, rootState }, data) {
    const that = this._vm;
    const activeClientID = rootState.common.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/ignored-insights`;
    const notification = {
      code: "urgent",
      title: "An error occurred during ignore insight.Please try again.",
    }
    commit("notifications/removeNotification", notification, { root: true });

    try {
      const response = await that.$constants('$http').post(url, data);
      return response;
    } catch (error) {
      if (hasCancelRequest(error))return;
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async deleteIgnoredInsight({ commit, rootState }, data) {
    const that = this._vm;
    const activeClientID = rootState.common.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/ignored-insights`;
    const config = { params: data };
    const notification = {
      code: "urgent",
      title: "An error occurred during activating insight.Please try again.",
    }
    commit("notifications/removeNotification", notification, { root: true });
    try {
      const response = await that.$constants('$http').delete(url, config);
      return response;
    } catch (error) {
      if (hasCancelRequest(error))return;
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async createPublicInsightPost({rootState, commit }, data) {
    const that = this._vm;
    const url = `v1/public-insight-posts`;
    const notification = {
      code: "urgent",
      title: "An error occurred during creating public insight post.Please try again.",
    }
    commit("notifications/removeNotification", notification, { root: true });
    try {
      const response = await that.$constants('$http').post(url, data);
      return response;
    } catch (error) {
      if (hasCancelRequest(error))return;
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async createInProgressInsight({ commit, rootState }, data) {
    const that = this._vm;
    const activeClientID = rootState.common.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/in-progress-insights`;
    const notification = {
      code: "urgent",
      title: "An error occurred during creating in-progress insight.Please try again.",
    }
    commit("notifications/removeNotification", notification, { root: true });
    try {
      const response = await that.$constants('$http').post(url,data);
      return response;
    } catch (error) {
      if (hasCancelRequest(error))return ;
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async deleteInProgressInsight({ commit, rootState }, data){
    const that = this._vm;
    const activeClientID = rootState.common.generalLocalStorageVariables.activeClientID;
    const url=`v1/clients/${activeClientID}/in-progress-insights/${data.insightID}`;
    const config = { params: data };
    const notification = {
      code: "urgent",
      title: "A error occurred when removing your insight from the in-progress stage.Please try again.",
    }
    commit("notifications/removeNotification", notification, { root: true });
    try {
      const response = await that.$constants('$http').delete(url, config);
      return response;
    } catch (error) {
      if (hasCancelRequest(error))return ;
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async searchPackagesInsights({ rootState,commit }, text) {
    const that = this._vm;
    const data = {
      activeClientID: rootState.common.generalLocalStorageVariables.activeClientID,
      searchText: text
    };
    const url="v1/search/insight";

    try {
      const response = await that.$constants('$http').post(url,data);
      commit('setSearchedInsightsResults',response.data.data);
      commit('common/setApisLoadStates', { api: 'searchPackagesInsights', isLoaded: true }, { root: true });
    } catch (error) {
      if (hasCancelRequest(error))return;
      const notification = {
        code: "urgent",
        title: "An error occurred during searching insights. Please try again."
      };
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async setWeeklyInsightChanges({ rootState, commit }) {
    const url = "package/insight/changes/weekly/get";
    const that = this._vm;
    const data = {
      clientID: rootState.common.generalLocalStorageVariables.activeClientID,
    }

    commit('common/setApisLoadStates', { api: 'weeklyInsightChanges',  isCalled: true, isLoaded: false }, { root: true });

    try {

      const response = await that.$constants('axios').post(url, data);
      commit('setWeeklyInsightChanges', response.data);
      commit('common/setApisLoadStates', { api: 'weeklyInsightChanges', isLoaded: true }, { root: true });

    } catch (error) {
      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during loading weekly insight changes. Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    }
  },
};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/insights/actions.js